import { render } from "./ResetPassword.vue?vue&type=template&id=6c3bb21b&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=6c3bb21b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3bb21b"]])

export default __exports__